import { Text, View } from 'react-native'
import { styled } from '~/core/styled'
import { convertLineHeight, convertPercentageToNumber } from '~/utils'

export const Title = styled(Text, theme => {
  return {
    base: {
      color: theme.colorTextNeutralDefault,
      fontFamily: theme.fontFamily.semiBold,
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
    },
    variants: {
      size: {
        default: {
          fontSize: theme.fontSizeThreeandhalfpulse,
          lineHeight: convertLineHeight(
            theme.fontSizeThreeandhalfpulse,
            theme.lineHeightSmall
          ),
        },
        xs: {
          fontSize: theme.fontSizeFivepulse,
          lineHeight: convertLineHeight(
            theme.fontSizeFivepulse,
            theme.lineHeightSmall
          ),
        },
      },
    },
  }
})

export const Container = styled(View, theme => {
  return {
    base: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacingInlineTwopulse,
      backgroundColor: 'transparent',
    },
    variants: {
      type: {
        interactive: {
          maxWidth: '90%',
        },
        title: {},
      },
    },
  }
})
